import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deletePhonecentersSysModel = ({ phonecentersSysModelId }: { phonecentersSysModelId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/PhonecentersSysModels/DeletePhonecentersSysModel/${phonecentersSysModelId}`);
};

type QueryFnType = typeof deletePhonecentersSysModel;

type UseDeletePhonecentersSysModelOptions = {
  phonecentersSysModelId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeletePhonecentersSysModel = ({ config }: UseDeletePhonecentersSysModelOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllPhonecentersSysModels"]);
      addNotification(`Το Μοντέλο Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deletePhonecentersSysModel,
  });
};
